import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import './journey-mix.css';

interface JourneyMixChartProps {
  journeys: ReadonlyArray<{ id: string; name: string; sessionCount: number; completionRate: number }>;
}

/** Categorical palette, ordered so adjacent slices stay distinguishable. */
const PALETTE = ['#5b4ee9', '#1fc7bd', '#8b7bf0', '#4a90f7', '#f5a524', '#c9d0da'];

export function JourneyMixChart({ journeys }: JourneyMixChartProps) {
  const top = [...journeys].sort((a, b) => b.sessionCount - a.sessionCount).slice(0, 6);
  const total = top.reduce((sum, journey) => sum + journey.sessionCount, 0);

  if (total === 0) return <p className="chart-empty">Aucun parcours mesuré.</p>;

  return (
    <div className="mix">
      <ResponsiveContainer width="100%" height={168}>
        <PieChart>
          <Pie
            data={top}
            dataKey="sessionCount"
            nameKey="name"
            innerRadius={52}
            outerRadius={78}
            paddingAngle={2}
            stroke="none"
          >
            {top.map((journey, index) => (
              <Cell key={journey.id} fill={PALETTE[index % PALETTE.length]} />
            ))}
          </Pie>
          <Tooltip
            contentStyle={{ border: '1px solid #eaedf1', borderRadius: 10, fontSize: 12 }}
            formatter={(value: number) => [`${value.toLocaleString('fr-FR')} sessions`, '']}
          />
        </PieChart>
      </ResponsiveContainer>

      <ul className="mix__legend">
        {top.map((journey, index) => (
          <li key={journey.id}>
            <span className="mix__swatch" style={{ background: PALETTE[index % PALETTE.length] }} />
            <span className="mix__name" title={journey.name}>
              {journey.name}
            </span>
            <span className="mix__value">{Math.round((journey.sessionCount / total) * 100)}%</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
